<template>
  <v-container fluid>
    <div class="d-flex align-center mb-2">
      <div class="ml-1 font-weight-medium">[102] บันทึกเวลา - มือถือ</div>
      <v-spacer></v-spacer>
      <div>
        <v-btn
          :disabled="
            (uiCtrl && !uiCtrl.isEnable('btn:::report:report_102:pdf:get')) ||
            (uiCtrl && !uiCtrl.isEnable('btn:::report:report_102:get'))
          "
          depressed
          class="mr-3"
          @click="handleDownloadFilePdf"
        >
          <v-icon left color="error">mdi-file-pdf-box</v-icon>
          Pdf
        </v-btn>
        <v-btn
          :disabled="
            (uiCtrl && !uiCtrl.isEnable('btn:::report:report_102:excel:get')) ||
            (uiCtrl && !uiCtrl.isEnable('btn:::report:report_102:get'))
          "
          depressed
          @click="handleDownloadFileExcel"
        >
          <v-icon left color="success">mdi-file-excel-box</v-icon>
          Excel
        </v-btn>
      </div>
    </div>
    <v-card outlined min-width="100%" class="px-3 mb-1">
      <div class="d-flex align-end flex-wrap py-2">
        <div class="mr-2">
          <div style="color: #555; font-size: 12px; margin-left: 5px">
            วันที่เริ่มต้น
          </div>
          <date-picker
            v-model="dateStart"
            type="datetime"
            format="DD/MM/YYYY HH:mm"
            :clearable="false"
            :disabled-date="disabledAfterDateEnd"
            :disabled-time="disabledAfterDateEnd"
          ></date-picker>
        </div>
        <div class="mr-2">
          <div style="color: #555; font-size: 12px; margin-left: 5px">
            วันที่สิ้นสุด
          </div>
          <date-picker
            v-model="dateEnd"
            type="datetime"
            format="DD/MM/YYYY HH:mm"
            :clearable="false"
            :disabled-date="disabledBeforeDateStart"
            :disabled-time="disabledBeforeDateStart"
          ></date-picker>
        </div>
        <div class="mr-2">
          <div style="color: #555; font-size: 12px; margin-left: 5px">
            หน่วยงาน
          </div>
          <v-card
            min-height="42"
            min-width="240"
            class="pa-2"
            outlined
            @click="dialogOrganization = true"
          >
            <span v-if="selectedOrganizations.length === 1">
              <v-chip
                small
                v-for="organization in selectedOrganizations.slice(0, 1)"
                :key="organization.organization_uuid"
              >
                {{ organization.title_th }}
              </v-chip>
            </span>
            <span
              v-else-if="selectedOrganizations.length > 1"
              style="color: #555; font-size: 13px"
            >
              {{ selectedOrganizations.length }} หน่วยงาน
            </span>
          </v-card>
        </div>
        <div class="mr-4">
          <div style="color: #555; font-size: 12px; margin-left: 5px">
            พนักงาน
          </div>
          <v-card
            min-height="42"
            min-width="240"
            class="pa-2"
            outlined
            @click="dialogEmployee = true"
          >
            <span v-if="employeesSelected.length === 1">
              <v-chip
                small
                v-for="employee in employeesSelected.slice(0, 1)"
                :key="employee.employee_uuid"
              >
                {{ employee.firstname_th }} {{ employee.lastname_th }}
              </v-chip>
            </span>
            <span
              v-else-if="employeesSelected.length > 1"
              style="color: #555; font-size: 13px"
            >
              พนักงาน {{ employeesSelected.length }} คน
            </span>
          </v-card>
        </div>
        <div class="mt-2 mb-1">
          <v-btn
            :disabled="
              loading ||
              employeesSelected.length === 0 ||
              (uiCtrl && !uiCtrl.isEnable('btn:::report:report_102:get'))
            "
            depressed
            color="primary"
            @click="handleGetDataFromApi"
            >ตกลง</v-btn
          >
        </div>
      </div>
    </v-card>

    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      :loading-text="loadingText"
      :headers="headers"
      :items="reports102"
      :options.sync="options"
      :server-items-length="totalReports102"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50, 100],
        itemsPerPageText: 'Row per page:',
      }"
      must-sort
    >
      <template v-slot:item.employee="{ item }">
        {{ item.firstname_th }} {{ item.lastname_th }}
      </template>
      <template v-slot:item.transaction_time="{ item }">
        {{ item | dateFormat }}
      </template>
      <template v-slot:item.company_duty="{ item }">
        <span v-if="item.company_duty">
          {{ item.company_duty.title_th }}
        </span>
        <span v-else></span>
      </template>
      <template v-slot:item.location="{ item }">
        <span v-if="item.location_title_th">
          <v-menu top offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                v-on="on"
                style="cursor: pointer"
                onMouseOver="this.style.textDecoration='underline'"
                onMouseOut="this.style.textDecoration='none'"
              >
                {{ item.location_title_th || '' }}
              </div>
            </template>

            <v-list>
              <v-list-item>
                <v-list-item-title>
                  {{ item.latitude || '-' }}, {{ item.longitude || '-' }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
        <span v-else-if="item.latitude && item.longitude">
          {{ parseFloat(item.latitude).toFixed(5) }},
          {{ parseFloat(item.longitude).toFixed(5) }}
        </span>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogProgress" persistent width="320">
      <div class="pa-4 white">
        <v-progress-linear :value="progressValue" height="25">
          <strong>{{ Math.ceil(progressValue) }}%</strong>
        </v-progress-linear>
      </div>
    </v-dialog>

    <v-dialog v-model="dialogOrganization" persistent scrollable width="480px">
      <v-card>
        <v-card-title class="pt-0 pb-4">
          <v-checkbox
            :disabled="loadingOrganization"
            label="เลือกทั้งหมด"
            hide-details
            :input-value="
              statusSelectedAllOrganization &&
              statusSelectedAllEmployee === 'all'
            "
            @change="handleSelectedAllOrganization($event)"
          ></v-checkbox>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0" style="height: 320px">
          <div class="px-6 py-2">
            <v-text-field
              v-model="searchOrganization"
              :loading="loadingOrganization"
              outlined
              placeholder="ค้นหา"
              prepend-inner-icon="mdi-magnify"
              dense
              hide-details
              clearable
              @input="handleSearchOrganization"
            ></v-text-field>
          </div>
          <ul style="list-style: none">
            <organization-tree-item
              v-for="organization in organizations"
              :key="organization.organization_uuid"
              :organization="organization"
              :loadingOrganization="loadingOrganization"
              :handleSelectedOrganization="handleSelectedOrganization"
            />
          </ul>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="loadingOrganization"
            color="primary"
            text
            @click="handleDialogOrganization"
          >
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEmployee" persistent width="480px">
      <v-card>
        <v-card-title class="pt-0 pb-4">
          <v-checkbox
            label="เลือกทั้งหมด"
            hide-details
            :input-value="statusSelectedAllEmployee === 'all'"
            :indeterminate="statusSelectedAllEmployee === 'indeterminate'"
            @change="handleSelectedAllEmployee($event)"
          ></v-checkbox>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0">
          <div class="px-6 py-2">
            <v-text-field
              v-model="searchEmployee"
              outlined
              placeholder="ค้นหา"
              prepend-inner-icon="mdi-magnify"
              dense
              hide-details
              clearable
            ></v-text-field>
          </div>
          <RecycleScroller
            style="height: 320px"
            :items="filterEmployees"
            :item-size="46"
            key-field="employee_uuid"
            v-slot="{ item }"
          >
            <div>
              <v-checkbox
                class="px-6 py-0 mt-3 mx-0"
                :label="`${item.employee_code} - ${item.firstname_th} ${item.lastname_th}`"
                :input-value="item.checked"
                @change="handleSelectedEmployee($event, item)"
                hide-details
              ></v-checkbox>
            </div>
          </RecycleScroller>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="handleDialogEmployee">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
// import DatePickerReport from '@/components/DatePickerReport.vue'
import OrganizationTreeItem from '@/components/OrganizationTreeItem.vue'

export default {
  components: {
    RecycleScroller,
    DatePicker,
    // DatePickerReport,
    OrganizationTreeItem,
  },
  data() {
    return {
      dateStart: new Date(new Date().setHours(0, 0, 0, 0)),
      dateEnd: new Date(new Date().setHours(23, 59, 59, 0)),
      searchOrganization: '',
      loadingOrganization: false,
      searchEmployee: '',
      statusSelectedAllOrganization: false,
      selectedOrganizations: [],
      organizations: [],
      employees: [],
      dialogOrganization: false,
      dialogEmployee: false,
      dialogProgress: false,
      progressValue: 0,
      interval: null,
      timeout: null,
      sortBy: ['employee_code'],
      sortDesc: [false],
      loading: false,
      options: {},
      loadingText: 'Loading... Please wait',
    }
  },
  filters: {
    dateFormat: function (item) {
      return moment
        .utc(item.transaction_time)
        .utcOffset(item.timezone)
        .format('DD/MM/YYYY HH:mm:ss')
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    employeesSelected() {
      return this.employees.filter((employee) => employee.checked)
    },
    statusSelectedAllEmployee() {
      if (_.every(this.employees, ['checked', true])) {
        return 'all'
      } else if (_.some(this.employees, ['checked', true])) {
        return 'indeterminate'
      } else {
        return 'blank'
      }
    },
    filterEmployees() {
      let items = this.employees

      if (this.searchEmployee) {
        items = items.filter((item) => {
          return (
            item.employee_code
              .toLowerCase()
              .includes(this.searchEmployee.toLowerCase()) ||
            item.firstname_th
              .toLowerCase()
              .includes(this.searchEmployee.toLowerCase()) ||
            item.lastname_th
              .toLowerCase()
              .includes(this.searchEmployee.toLowerCase())
          )
        })
      }

      return items
    },
    headers() {
      return [
        {
          text: 'รหัสพนักงาน',
          align: 'start',
          value: 'employee_code',
        },
        {
          text: 'ชื่อ - สกุล',
          value: 'employee',
        },
        {
          text: 'เวลา (เวลาท้องถิ่น)',
          value: 'transaction_time',
        },
        {
          text: 'สถานะ',
          value: 'company_duty',
        },
        {
          text: 'สถานที่',
          sortable: false,
          value: 'location',
        },
        {
          text: 'หมายเหตุ',
          value: 'note',
        },
      ]
    },
    totalReports102() {
      return this.$store.state.report.totalReports102
    },
    reports102() {
      return this.$store.state.report.reports102
    },
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: '[102] บันทึกเวลา - มือถือ',
        disabled: true,
      },
    ])

    this.$store.state.loading = true

    const { company_uuid } = this.$store.state.authentication.company

    try {
      const [organizations, employees] = await Promise.all([
        this.fetchOrganizationsAuthorizedTree({
          company_uuid,
          params: {
            dpc: 'report-102-to-list-organization-tree',
            field: 'organization_uuid,title_th', // not working
          },
        }),
        this.fetchEmployeesAuthorized({
          company_uuid,
          params: {
            dpc: 'report-102-to-list-employee',
            preset: 'selector',
          },
        }),
      ])

      const map = (arr) => {
        return arr ? arr.map(fix) : null
      }
      const fix = (item) => {
        return {
          ...item,
          checked: false,
          children: map(item.children),
        }
      }
      this.organizations = map(organizations)

      this.employees = employees.map((employee) => {
        return { ...employee, checked: false }
      })

      this.$store.state.loading = false
    } catch (error) {
      this.$store.state.loading = false

      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    }
  },
  methods: {
    ...mapActions({
      generateFileExcel: 'download/generateFileExcel',
      generateFilePdf: 'download/generateFilePdf',
      generateFileProgress: 'download/generateFileProgress',
      fetchReports102: 'report/fetchReports102',
      fetchOrganizationsAuthorizedTree:
        'organization/fetchOrganizationsAuthorizedTree',
      fetchEmployeesAuthorized: 'employee/fetchEmployeesAuthorized',
    }),
    disabledAfterDateEnd(date) {
      return date > new Date(this.dateEnd)
    },
    disabledBeforeDateStart(date) {
      return date < new Date(this.dateStart)
    },
    handleGetDataFromApi() {
      this.getDataFromApi()
    },
    handleSearchOrganization() {
      this.loadingOrganization = true
      this.getOrganizationsFilterBySearch()
    },
    getOrganizationsFilterBySearch: _.debounce(async function () {
      const organizations = await this.getOrganizationsAuthorizedTree()

      const map = (arr) => {
        return arr ? arr.map(fix) : null
      }
      const fix = (item) => {
        return {
          ...item,
          checked: this.selectedOrganizations.some(
            (org) => org.organization_uuid === item.organization_uuid
          ),
          children: map(item.children),
        }
      }
      this.organizations = map(organizations)
    }, 1000),
    async getOrganizationsAuthorizedTree() {
      try {
        const { company_uuid } = this.$store.state.authentication.company
        const payload = {
          company_uuid,
          params: {
            dpc: 'report-102-to-list-organization-tree',
            search: this.searchOrganization || '',
          },
        }
        const organizations = await this.fetchOrganizationsAuthorizedTree(
          payload
        )
        return organizations
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loadingOrganization = false
      }
    },
    handleSelectedAllOrganization(checked) {
      this.statusSelectedAllOrganization = checked

      this.organizations.forEach((organization) => {
        const result = this.setCheckAllOrganizationRecursive(organization)
        this.handleSelectedOrganization(result)
      })
    },
    setCheckAllOrganizationRecursive(organization) {
      organization.checked = this.statusSelectedAllOrganization

      if (organization.children && organization.children.length) {
        organization.children.forEach((children) => {
          this.setCheckAllOrganizationRecursive(children)
        })
      }
      return organization
    },
    handleSelectedOrganization(organization) {
      this.setCheckOrganizationRecursive(organization)

      this.employees = this.employees.map((employee) => {
        if (
          this.selectedOrganizations.some(
            (org) =>
              org.organization_uuid === employee.organization.organization_uuid
          )
        ) {
          return { ...employee, checked: true }
        }
        return { ...employee, checked: false }
      })
    },
    setCheckOrganizationRecursive(organization) {
      if (organization.checked) {
        const index = this.selectedOrganizations.findIndex(
          (org) => org.organization_uuid === organization.organization_uuid
        )
        if (index === -1) {
          this.selectedOrganizations = [
            ...this.selectedOrganizations,
            organization,
          ]
        }
      } else {
        this.selectedOrganizations = this.selectedOrganizations.filter(
          (org) => org.organization_uuid !== organization.organization_uuid
        )
      }

      if (organization.children && organization.children.length) {
        organization.children.forEach((children) => {
          this.setCheckOrganizationRecursive(children)
        })
      }
    },
    handleSelectedAllEmployee(checked) {
      this.employees = this.employees.map((employee) => ({
        ...employee,
        checked,
      }))

      this.handleSelectedAllOrganization(checked)
    },
    handleSelectedEmployee(checked, employee) {
      const { employee_uuid } = employee

      this.employees = this.employees.map((employee) => {
        if (employee.employee_uuid === employee_uuid) {
          return { ...employee, checked }
        }
        return employee
      })
    },
    handleDialogOrganization() {
      this.dialogOrganization = false
      this.searchOrganization = ''

      this.options.page = 1
    },
    handleDialogEmployee() {
      this.dialogEmployee = false
      this.searchEmployee = ''

      this.options.page = 1
    },
    downloadProgress(job_process_uuid, ping_after_ms) {
      this.interval = setInterval(() => {
        this.generateFileProgress(job_process_uuid)
          .then((res) => {
            if (res.total === 0) {
              this.progressValue = 100
              this.timeout = setTimeout(() => {
                this.dialogProgress = false
              }, 200)

              clearInterval(this.interval)

              const snackbar = {
                show: true,
                color: 'warning',
                timeout: 4000,
                message: 'ไม่มีข้อมูล',
              }

              this.$store.commit('SET_SNACKBAR', snackbar)
              return
            }

            if (res.is_success) {
              this.progressValue = 100
              this.timeout = setTimeout(() => {
                clearInterval(this.interval)
                this.dialogProgress = false

                const fileUrl = res.resource_uri
                const fileName = fileUrl.split('/').pop()

                const a = document.createElement('a')
                a.setAttribute('hidden', '')
                a.setAttribute('href', fileUrl)
                a.setAttribute('target', '_blank')
                a.setAttribute('download', fileName)
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
              }, 200)
            } else {
              // this.progressValue = (100 / res.total) * res.progress
              if (this.progressValue < 60) {
                this.progressValue += 10
              } else if (this.progressValue < 80) {
                this.progressValue += 5
              } else if (this.progressValue < 95) {
                this.progressValue += 1
              } else {
                this.progressValue = 95
              }
            }
          })
          .catch((error) => {
            clearInterval(this.interval)
            this.dialogProgress = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }, ping_after_ms)
    },
    handleDownloadFileExcel() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      let order_by = ''
      const sortByKey = sortBy[0] || ''

      if (sortByKey === 'employee_code') order_by = 'employee_code'
      if (sortByKey === 'employee') order_by = 'firstname_th'
      if (sortByKey === 'transaction_time') order_by = 'transaction_time'
      if (sortByKey === 'company_duty') order_by = 'company_duty_title_th'
      if (sortByKey === 'note') order_by = 'note'

      if (sortDesc.length > 0) {
        if (sortDesc[0]) {
          order_by += `,desc`
        } else {
          order_by += `,asc`
        }
      }

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        body: {
          start_datetime: this.dateStart
            ? moment(this.dateStart).format('YYYY-MM-DD HH:mm:ss')
            : null,
          end_datetime: this.dateEnd
            ? moment(this.dateEnd).format('YYYY-MM-DD HH:mm:ss')
            : null,
          order_by: order_by ? order_by : null,
          limit: null,
          employee_uuids: this.employeesSelected.length
            ? this.employeesSelected.map((e) => e.employee_uuid)
            : [],
          is_locale_en: false,
        },
        reportType: 'report-102',
        params: {
          dpc: 'report-102-excel-to-list-report-102-excel',
        },
      }

      this.generateFileExcel(payload)
        .then((res) => {
          if (res.total === 0) {
            const snackbar = {
              show: true,
              color: 'warning',
              timeout: 4000,
              message: 'ไม่มีข้อมูล',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)
            return
          }

          this.progressValue = 0
          this.dialogProgress = true

          this.downloadProgress(res.job_process_uuid, res.ping_after_ms)
        })
        .catch((error) => {
          this.dialogProgress = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    handleDownloadFilePdf() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      let order_by = ''
      const sortByKey = sortBy[0] || ''

      if (sortByKey === 'employee_code') order_by = 'employee_code'
      if (sortByKey === 'employee') order_by = 'firstname_th'
      if (sortByKey === 'transaction_time') order_by = 'transaction_time'
      if (sortByKey === 'company_duty') order_by = 'company_duty_title_th'
      if (sortByKey === 'note') order_by = 'note'

      if (sortDesc.length > 0) {
        if (sortDesc[0]) {
          order_by += `,desc`
        } else {
          order_by += `,asc`
        }
      }

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        body: {
          start_datetime: this.dateStart
            ? moment(this.dateStart).format('YYYY-MM-DD HH:mm:ss')
            : null,
          end_datetime: this.dateEnd
            ? moment(this.dateEnd).format('YYYY-MM-DD HH:mm:ss')
            : null,
          order_by: order_by ? order_by : null,
          limit: null,
          employee_uuids: this.employeesSelected.length
            ? this.employeesSelected.map((e) => e.employee_uuid)
            : [],
          is_locale_en: false,
        },
        reportType: 'report-102',
        params: {
          dpc: 'report-102-pdf-to-list-report-102-pdf',
        },
      }

      this.generateFilePdf(payload)
        .then((res) => {
          if (res.total === 0) {
            const snackbar = {
              show: true,
              color: 'warning',
              timeout: 4000,
              message: 'ไม่มีข้อมูล',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)
            return
          }

          this.progressValue = 0
          this.dialogProgress = true

          this.downloadProgress(res.job_process_uuid, res.ping_after_ms)
        })
        .catch((error) => {
          this.dialogProgress = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    getDataFromApi() {
      if (this.employeesSelected.length === 0) return

      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      let order_by = ''
      const sortByKey = sortBy[0] || ''

      if (sortByKey === 'employee_code') order_by = 'employee_code'
      if (sortByKey === 'employee') order_by = 'firstname_th'
      if (sortByKey === 'transaction_time') order_by = 'transaction_time'
      if (sortByKey === 'company_duty') order_by = 'company_duty_title_th'
      if (sortByKey === 'note') order_by = 'note'

      if (sortDesc.length > 0) {
        if (sortDesc[0]) {
          order_by += `,desc`
        } else {
          order_by += `,asc`
        }
      }

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        body: {
          start_datetime: this.dateStart
            ? moment(this.dateStart).format('YYYY-MM-DD HH:mm:ss')
            : null,
          end_datetime: this.dateEnd
            ? moment(this.dateEnd).format('YYYY-MM-DD HH:mm:ss')
            : null,
          limit: `${itemsPerPage},${(page - 1) * itemsPerPage}`,
          order_by: order_by ? order_by : null,
          employee_uuids: this.employeesSelected.length
            ? this.employeesSelected.map((e) => e.employee_uuid)
            : [],
        },
        params: {
          dpc: 'report-102-to-list-report-102',
        },
      }

      this.fetchReports102(payload)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
    clearInterval(this.interval)

    this.$store.commit('report/SET_REPORTS_102', [])
  },
}
</script>

<style>
.mx-input {
  padding: 20px 10px;
}
/* .mx-datepicker {
  width: 180px;
} */
</style>
